var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTiktok(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1045_13555)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 50,
    height: 50,
    rx: 12,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.381 0H5.61896C2.5158 0 0 2.5158 0 5.61896V46.381C0 49.4842 2.5158 52 5.61896 52H46.381C49.4842 52 52 49.4842 52 46.381V5.61896C52 2.5158 49.4842 0 46.381 0ZM42.0403 22.6524C38.7484 22.6524 35.698 21.5994 33.2076 19.8119V32.7125C33.2076 39.1562 27.966 44.3978 21.5233 44.3978C19.0339 44.3978 16.725 43.6126 14.827 42.2797C11.8141 40.1646 9.83902 36.6658 9.83902 32.7125C9.83902 26.2698 15.0806 21.0282 21.5233 21.0282C22.0579 21.0282 22.5824 21.0719 23.0977 21.1419V27.6231C22.5996 27.4669 22.0721 27.3766 21.5233 27.3766C18.5804 27.3766 16.1874 29.7707 16.1874 32.7125C16.1874 34.7617 17.3489 36.542 19.0481 37.4357C19.7886 37.8263 20.6296 38.0495 21.5233 38.0495C24.3982 38.0495 26.7426 35.7629 26.8491 32.9134L26.8592 7.47234H33.2076C33.2076 8.02216 33.2613 8.55981 33.3577 9.08225C33.8061 11.5017 35.2415 13.5762 37.2298 14.8737C38.6155 15.7765 40.267 16.304 42.0403 16.304V22.6524Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1045_13555"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 52,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTiktok);
export default __webpack_public_path__ + "static/media/tiktok.ffbaacba502ee9ed2adf6d1b5039e005.svg";
export { ForwardRef as ReactComponent };